const setSecondChildrenCitizenId = (data = null) => {
  return {
    type: 'SET_SECONDCHILDRENCITIZENID',
    data
  }
}

export default {
  setSecondChildrenCitizenId,
}
